/* @flow */
import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import styles from './select-bank.scss';

class SelectBank extends React.Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    changed: PropTypes.func.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.handleChangedBank = this.handleChangedBank.bind(this);
    this.changedBank = this.changedBank.bind(this);
  }

  handleChangedBank (event) {
    event.preventDefault();
    const bank = event.target.value;
    this.changedBank(bank);
  }

  changedBank (value) {
    this.props.changed(value);
  }

  render () {
    return (
      <div className={'input-wrapper styled-select ' + styles.container}>
        <select
          name='bank-picker'
          value={this.props.value}
          onChange={this.handleChangedBank}
          className={styles.select}>

          <option disabled="true" value="INITIAL">
            {proxyCounterpart('SELECT_BANK_INITIAL')}
          </option>

          <option value="HANDELSBANKEN">
            {proxyCounterpart('SELECT_BANK_HANDELSBANKEN')}
          </option>

          <option value="NORDEA_PERSON">
            {proxyCounterpart('SELECT_BANK_NORDEA_PERSON')}
          </option>

          <option value="NORDEA_KONTO">
            {proxyCounterpart('SELECT_BANK_NORDEA_KONTO')}
          </option>

          <option value="SWEDBANK">
            {proxyCounterpart('SELECT_BANK_SWEDBANK')}
          </option>

          <option value="SEB">
            {proxyCounterpart('SELECT_BANK_SEB')}
          </option>

          <option value="IBAN">
            {proxyCounterpart('SELECT_BANK_IBAN')}
          </option>

          <option value="OTHER">
            {proxyCounterpart('SELECT_BANK_OTHER')}
          </option>

        </select>
        <label htmlFor="bank-picker"><Translate content='BANK'/></label>
      </div>
    );
  }
}

export default SelectBank;




/** WEBPACK FOOTER **
 ** ./src/views/settings/salary-info/select-bank.js
 **/